import { useOidc } from '@axa-fr/react-oidc';
import type { PropsWithChildren } from 'react';
import { useTranslation } from 'react-i18next';
import { AuthLoading } from '#pie/components/auth-loading/AuthLoading';
import { Text } from '#pie/components/text/Text';
import { VITE_FEATURE_FLAGS_PREFIX } from '#pie/env';
import { useGetFeatureFlags } from '#pie/internal/api/pie-bff';
import Logo from '../../assets/logo.svg?react';
import { Stack } from '../stack/Stack';

export function MaintenanceGate({ children }: PropsWithChildren) {
  const { isAuthenticated } = useOidc();
  const { t } = useTranslation();
  const { data: flags, isPending } = useGetFeatureFlags({
    query: {
      enabled: isAuthenticated,
      staleTime: Number.POSITIVE_INFINITY,
      gcTime: Number.POSITIVE_INFINITY,
    },
  });

  if (!isAuthenticated) return children;
  if (isPending) return <AuthLoading />;

  if (flags?.[`${VITE_FEATURE_FLAGS_PREFIX}maintenance`] === true) {
    return (
      <main className="min-h-screen bg-surface-page text-content-body">
        <header className="border-b border-border-divider bg-action-primary-enabled">
          <div className="mx-auto flex min-h-20 max-w-7xl items-center px-6 md:px-10">
            <Logo
              aria-label="Partners in Energie"
              className="h-14 w-20 text-white"
              role="img"
            />
          </div>
        </header>
        <div className="mx-auto grid min-h-[calc(100svh-5rem)] max-w-7xl content-start px-6 pt-60 md:px-10">
          <section aria-labelledby="maintenance-heading" className="max-w-3xl">
            <Stack gap="md">
              <Text as="h1" id="maintenance-heading" variant="h1">
                {t('maintenance-gate.title')}
              </Text>
              <Text className="max-w-2xl">{t('maintenance-gate.text')}</Text>
            </Stack>
          </section>
        </div>
      </main>
    );
  }

  return children;
}
